
export const stitchedImages = (images) => {
  return new Promise((resolve, reject) => {
    if (!Array.isArray(images) || images.length === 0) {
      return reject(new Error("No images provided"));
    }

    const A4_WIDTH = 2480; // 8.27 inches * 300 DPI

    const loadedImages = [];
    let loadedCount = 0;

    // Load all images
    images.forEach((src, index) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = src;

      img.onload = () => {
        loadedImages[index] = img;
        loadedCount++;
        if (loadedCount === images.length) {
          stitchAll();
        }
      };

      img.onerror = (err) => reject(err);
    });

    const stitchAll = () => {
      // Calculate scaled heights to maintain aspect ratio
      const scaledHeights = loadedImages.map((img) =>
        Math.floor((A4_WIDTH / img.width) * img.height)
      );

      // Total height for the canvas
      const totalHeight = scaledHeights.reduce((sum, h) => sum + h, 0);

      // Create canvas
      const canvas = document.createElement("canvas");
      canvas.width = A4_WIDTH;
      canvas.height = totalHeight;

      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.imageSmoothingEnabled = true;

      // Draw each image stacked vertically
      let yOffset = 0;
      loadedImages.forEach((img, idx) => {
        ctx.drawImage(img, 0, yOffset, A4_WIDTH, scaledHeights[idx]);
        yOffset += scaledHeights[idx];
      });

      // Export as JPEG (high quality for printing)
      const stitchedBase64 = canvas.toDataURL("image/jpeg", 0.95);
      resolve(stitchedBase64);
    };
  });
};
